import { Pagination, ReferralAction, ReferralInfo, ReferralInvitedUser } from '../../interfaces';
import { Dispatch, SetStateAction } from 'react';
import { get } from '../../scripts';
import { API } from '../../data/30pay.api';

export const getReferralInfo = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    setData: Dispatch<SetStateAction<ReferralInfo | undefined>>,
) => {
    setLoading(true);
    await get<ReferralInfo>(API.referral.getMineReferralInfo).then((response) => {
        setLoading(false);
        setData(response.value.value);
    }).catch((e) => setLoading(false));
};

export const getReferralActions = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    setData: Dispatch<SetStateAction<Pagination<ReferralAction> | undefined>>,
    page: number,
    pageSize: number,
) => {
    setLoading(true);
    await get<Pagination<ReferralAction>>(API.referral.getMineReferralActions(page, pageSize))
        .then((response) => {
            setLoading(false);
            setData(response.value.value);
        })
        .catch((error) => setLoading(false));
};

export const getReferralInvitedUsers = async (
    setLoading: Dispatch<SetStateAction<boolean>>,
    setData: Dispatch<SetStateAction<Pagination<ReferralInvitedUser> | undefined>>,
    page: number,
    pageSize: number,
) => {
    setLoading(true);
    await get<Pagination<ReferralInvitedUser>>(API.referral.getMineInvitedUsers(page, pageSize))
        .then((response) => {
            setLoading(false);
            setData(response.value.value);
        })
        .catch((error) => setLoading(false));
};